import pendoMiddleware from './pendoMiddleware';
import * as t from './actionTypes';
import * as actions from './actions';

export { t, actions };

export default pendoMiddleware;
